import i18n from '../i18n'

export interface LocalizedName {
  name?: string | null
  nameEn?: string | null
  nameZh?: string | null
  nameZhCn?: string | null
}

export interface LocalizedDescription {
  description?: string | null
  descriptionEn?: string | null
  descriptionZh?: string | null
  descriptionZhCn?: string | null
}

export type LocalizedItem = LocalizedName & LocalizedDescription

function currentLanguage(): string {
  return i18n.language || 'zh-TW'
}

export function localizedName(item: LocalizedName | null | undefined): string {
  if (!item) return ''
  const lng = currentLanguage()
  if (lng === 'zh-CN') {
    return item.nameZhCn ?? item.nameZh ?? item.name ?? ''
  }
  if (lng.startsWith('en')) {
    return item.nameEn ?? item.name ?? ''
  }
  // zh-TW and fallback
  return item.nameZh ?? item.name ?? ''
}

export function localizedDescription(
  item: LocalizedDescription | null | undefined
): string {
  if (!item) return ''
  const lng = currentLanguage()
  if (lng === 'zh-CN') {
    return item.descriptionZhCn ?? item.descriptionZh ?? item.description ?? ''
  }
  if (lng.startsWith('en')) {
    return item.descriptionEn ?? item.description ?? ''
  }
  // zh-TW and fallback
  return item.descriptionZh ?? item.description ?? ''
}

export function dateLocale(lng?: string): string {
  const language = lng || currentLanguage()
  if (language.startsWith('en')) return 'en-US'
  if (language === 'zh-CN') return 'zh-CN'
  return 'zh-HK'
}

export function formatDate(
  timestamp: number | Date,
  lng?: string
): string {
  const date = typeof timestamp === 'number' ? new Date(timestamp * 1000) : timestamp
  return date.toLocaleDateString(dateLocale(lng))
}

export function formatDateTime(
  timestamp: number | Date,
  lng?: string
): string {
  const date = typeof timestamp === 'number' ? new Date(timestamp * 1000) : timestamp
  return date.toLocaleString(dateLocale(lng))
}
